export default "/_next/static/images/2f94e5fcff8663fc6ee398b864a79a8b.jpg";